import { useSelector } from 'react-redux';
import type { RecentDealsState, StateTree } from '../types';

/**
 * Custom React hook to select the recent deals state from the Redux store.
 *
 * @returns {RecentDealsState} The current recent deals state from the Redux store.
 */
export const useRecentDealsSelector = (): RecentDealsState => {
    const state: RecentDealsState = useSelector((state: StateTree) => state.recentDeals);
    return state;
};
